import { __decorate } from "tslib";
import { AsnProp } from "@peculiar/asn1-schema";
import { LogotypeDetails } from "./logotype_details";
import { LogotypeAudioInfo } from "./logotype_audio_info";
export class LogotypeAudio {
    constructor(params = {}) {
        this.audioDetails = new LogotypeDetails();
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: LogotypeDetails })
], LogotypeAudio.prototype, "audioDetails", void 0);
__decorate([
    AsnProp({ type: LogotypeAudioInfo, optional: true })
], LogotypeAudio.prototype, "audioInfo", void 0);
